import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {UpdateGroupInput, useCreateGroupMutation} from '../../graphql';
import {GroupNewContainer} from './container';
import {ErrorView} from '../GraphQL/ErrorView';
import {CombinedError} from 'urql';

export const GroupNewGraphQL = () => {
  const history = useHistory();
  const [error, setError] = useState<CombinedError | undefined>();
  const [createGroupResult, createGroupPromise] = useCreateGroupMutation();
  const createGroup = (values: UpdateGroupInput) => {
    createGroupPromise({input: values}).then((result) => {
      if (result.error) {
        return setError(result.error);
      }
      history.replace('/group/edit/' + result?.data?.createGroup?.result?.id);
    });
  }

  return (
    <ErrorView fetching={false} errors={[error]}>
      <GroupNewContainer createGroup={createGroup}/>
    </ErrorView>
  );
};
